module.exports = __webpack_public_path__ + "img/5.76d33acb.jpg";